const euros = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
});

/** "437,80 €": every amount of the invoice list, its tooltips included. */
export const formatEuros = (amount) => euros.format(amount);
